module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0124.jpg?v=e8535968";